@if (dataContext && form) {
  <form class="action-form lease-agreement-document-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="lease-agreement-document-form__header">
      <h2 class="lease-agreement-document-form__title">{{ 'LEASE_AGREEMENT_DOCUMENT.FORM_HEADER' | translate }}</h2>
      <p class="lease-agreement-document-form__help help-text">{{ 'ESIGNATURE.HELP_TEXT.LEASE_AGREEMENT_DOCUMENT_LINK' | translate }}</p>
    </div>
    <astral-form [form]="form" [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [columnGap]="'16px'">
      <div class="astral-grid-full">
        <div class="lease-agreement-document-form__upload">
          <app-single-file-upload (filesSelected)="onFileChange($event)"></app-single-file-upload>
        </div>
      </div>
      <astral-input class="astral-grid-full" [control]="form.controls['caption']"></astral-input>
      @if (esignSettingSelected) {
        <astral-toggle class="astral-grid-full" [control]="form.controls['sendForEsign']"></astral-toggle>
      }
      @if (form.controls['sendForEsign'].value) {
        <div class="astral-grid-desktop-span-2">
          <astral-input
            [control]="form.controls['errandDescription']"
            [helpText]="'ESIGNATURE.HELP_TEXT.DESCRIPTION'"
          ></astral-input>
        </div>
        <astral-date-picker
          [control]="form.controls['expirationDate']"
          [helpText]="'ESIGNATURE.HELP_TEXT.EXPIRATION_DATE'"
        ></astral-date-picker>
        <div class="astral-grid-full astral-form-stack astral-form-stack--relaxed">
          <h4 class="lease-agreement-document-form__section-title">{{ 'ESIGNATURE.SIGNATORIES' | translate }}</h4>
          <div class="astral-surface-stack">
            @for (sform of signatoryForms; track sform; let i = $index) {
              <div class="lease-agreement-document-form__signatory-card">
                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [columnGap]="'16px'">
                  <astral-input [control]="sform.controls['name']"></astral-input>
                  <astral-select
                    [control]="sform.controls['informationChannel']"
                    [itemsSource]="informationChannels"
                    [helpText]="'ESIGNATURE.HELP_TEXT.INFORMATION_CHANNEL'"
                  ></astral-select>
                  <astral-input [control]="sform.controls['email']" [type]="'email'" [inputMode]="'email'"></astral-input>
                  <astral-input [control]="sform.controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
                  <astral-select
                    [control]="sform.controls['signingRole']"
                    [itemsSource]="signingRoles"
                    [helpText]="'ESIGNATURE.HELP_TEXT.SIGNING_ROLE'"
                  ></astral-select>
                  <astral-select [control]="sform.controls['signatureType']" [itemsSource]="signatureTypeSelection"></astral-select>
                  <app-masked-text-box
                    [control]="sform.controls['civicNumber']"
                    [mask]="civicNumberMask"
                    [helpText]="'ESIGNATURE.HELP_TEXT.CIVIC_NUMBER'"
                    [maskFormat]="civicNumberMaskFormat"
                  ></app-masked-text-box>
                  <astral-select
                    [control]="sform.controls['signatureReminderSetting']"
                    [helpText]="'ESIGNATURE.HELP_TEXT.SIGNATURE_REMINDER_SETTING'"
                    [itemsSource]="signatureReminderSettingSelection"
                  ></astral-select>
                  @if (i > 0) {
                    <div class="lease-agreement-document-form__signatory-delete-slot astral-form-adjacent-action">
                      <astral-button variant="secondary" type="button" labelKey="DELETE_BTN" icon="trash" (click)="deleteSignatory(i)">
                      </astral-button>
                    </div>
                  }
                </astral-layout-group>
              </div>
            }
          </div>
          <div class="astral-form-adjacent-action">
            <astral-button variant="primary" size="small" type="button" labelKey="ESIGNATURE.ADD_SIGNATORY" icon="plus" (click)="newSignatory()">
            </astral-button>
          </div>
        </div>
      }
    </astral-form>
    <div class="lease-agreement-document-form__actions">
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      <astral-button type="submit" labelKey="SAVE_BTN"></astral-button>
    </div>
  </form>
}
